import React, { useContext, useEffect, useState } from 'react'
import IGuaranteedAmount from './guaranteed-amount.interface'
import GuaranteedAmountContext from './guaranteed-amount-context'
import AuthContext from '../auth/auth-context'
import Salary from './salary/salary'
import Spinner from '../spinner/spinner'
import DashboardContext from '../layout/dashboard-context'
import BugsnagContext from '../../context/bugsnag-context'
import api from '../../api'

const GuaranteedAmount: React.FC<IGuaranteedAmount> = () => {
  const { salaries, setSalaries } = useContext(GuaranteedAmountContext)
  const { token } = useContext(AuthContext)
  const { bugsnagClient } = useContext(BugsnagContext)
  const [isLoading, setIsLoading] = useState(false)
  const { selectedOrganization } = useContext(DashboardContext)
  const [hasReceivedData, setHasReceivedData] = useState(false)

  bugsnagClient.metaData = {
    token,
    page: 'guaranteed-amount',
  }

  const tableHeads = [
    {
      label: 'År',
    },
    {
      label: 'Garantibelopp',
    },
  ]

  const downloadFile = (blob, fileName) => {
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = fileName
    document.body.append(link)
    link.click()
    link.remove()
    setTimeout(() => {
      if (isLoading) {
        setIsLoading(false)
      }
      URL.revokeObjectURL(link.href)
    }, 3000)
  }

  const getGuaranteedAmount = async () => {
    try {
      setHasReceivedData(false)
      const res = await api.get(`/accounts/${selectedOrganization.id}/salaries`)
      setHasReceivedData(true)

      return res.data.data
    } catch (e) {
      bugsnagClient.notify(e)

      return []
    }
  }

  const getData = async () => {
    const data = await getGuaranteedAmount()
    data.sort((a: any, b: any) => {
      return b.year - a.year
    })
    setSalaries(data)
  }

  const handlePrint = async () => {
    console.log(selectedOrganization);
    try {
      setIsLoading(true)
      const res = await api.post(
        `/accounts/${selectedOrganization.id}/salaries/create-pdf`,
        {},
        { responseType: 'blob' },
      )
      console.log(res);

      if (res.data) {
        return downloadFile(res.data, 'garantibelopp')
      }
    } catch (e) {
      console.log(e);
    }
    //   bugsnagClient.notify(e)
    //   setIsLoading(false)
    // } finally {
    //   setIsLoading(false)
    // }
  }

  useEffect(() => {
    setSalaries([])
    getData()
  }, [selectedOrganization])

  return (
    <div className="card p-12 flex flex-col w-full bg-white gap-8">
      <div className="flex flex-col w-full gap-4">
        <h2>Garantibelopp</h2>
        <p>
          Garantibelopp baserat på 2% av föregående års årslönesumma som ni angivit till Fastigo.{' '}
          <br />
          <br />
          Enligt Fastigos stadgar §21 är varje medlem skyldig att utfärda en garantiförbindelse till
          Fastigo motsvarande 2% av medlems lönesumma näst föregående år. <br />
          Det ska betonas att ansvarsbeloppet ska ses som ett borgensåtagande och ska uppges i
          årsredovisningen för föregående år. Beloppet ska alltså <strong>inte</strong> betalas in.
        </p>
      </div>
      {hasReceivedData ? (
        <div className="w-full flex flex-col md:flex-row">
          <div className="w-full">
            <table className="table">
              <thead className="thead-blue">
                <tr className="tr">
                  {tableHeads.map((head, index) => {
                    return (
                      <th key={index} className="th md:w-1/2 font-bold">
                        {head.label}
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody className="tbody">
                {salaries && salaries.length > 0
                  ? salaries.map((salary, index) => {
                      return <Salary key={index} data={salary} />
                    })
                  : null}
              </tbody>
            </table>
            <div className="flex justify-start pt-8">
              <button disabled={isLoading} className="btn" onClick={() => handlePrint()}>
                {!isLoading ? 'Spara som pdf' : 'Laddar...'}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="m-40">
          <Spinner />
        </div>
      )}
    </div>
  )
}

export default GuaranteedAmount
